import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import {lazy,Suspense} from 'react';
import '@slickgrid-universal/common/dist/styles/css/slickgrid-theme-default.lite.css';
import './styles/index.css';
import '../app/styles/fonts/fonts.css';
import '../app/styles/styles.css';
import './styles/legacy-react.css';
import './styles/themes.css';
import './styles/statistics-dark.css';
import './styles/date-range.css';
import './styles/telegram-chat.css';
import './styles/media-review.css';
import './styles/messenger-v2.css';
import './features/files/user-access-layout.css';
import './features/creation/asset-toolbar.css';
import './features/files/public-video.css';
import './features/files/public-share.css';
import './features/files/public-share-viewport.css';
import './features/board/project-avatars.css';
import './pages/asset-filter-performance.css';

// A deploy replaces the hashed chunk files; a tab opened before the deploy
// would 404 on lazy-loading a page it hasn't visited yet.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) =>
        !(typeof error === 'object' && error !== null && 'status' in error && error.status === 401) &&
        failureCount < 2,
    },
  },
});
const GuestCallPage=lazy(()=>import('./chat/calls/GuestCallPage').then(module=>({default:module.GuestCallPage})));
const guestRoute=location.pathname.replace(/\/$/,'')===`${import.meta.env.BASE_URL.replace(/\/$/,'')}/call`;

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      {guestRoute ? <Suspense fallback={<p>Открываем приглашение…</p>}><GuestCallPage/></Suspense> : <AuthProvider>
        <App />
      </AuthProvider>}
    </BrowserRouter>
  </QueryClientProvider>,
);
